import React, { useState, useEffect, useCallback } from "react";
// import { get, apiUrl } from "../../../services/apiservices";
import "./docklist.css";
import back from "../../../assets/svg/backarrow.svg";
import dock from "../../../assets/svg/dock.svg";
import search from "../../../assets/svg/search.svg";
import filter from "../../../assets/svg/filter.svg";
import plus from "../../../assets/svg/plus.svg";
import vehicle from "../../../assets/svg/vehicle.svg";
import uparrow from "../../../assets/svg/uparrow.svg";
import edit from "../../../assets/svg/edit.svg";
import del from "../../../assets/svg/delete.svg";
import next from "../../../assets/svg/next.svg";
import close from "../../../assets/svg/close.svg";
import { Link } from "react-router-dom";
import DockAdd from "./dockadd";
import { format } from "date-fns";
import { Row, Col } from "react-bootstrap";
import df from "../../../assets/svg/df.svg";
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import "react-datepicker/dist/react-datepicker.css";
import SearchWithAPI from "../../searchbox/searchbox";
import { Toast, ToastContainer } from "react-bootstrap";
import { getDockMasterListApi } from "../master-api";
import { useNavigate } from "react-router-dom";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import DeleteModal from "../../common/delete-modal.js";
import mawalog from "../../../assets/svg/mawaloglogo.svg";

export default function DockMasterPage() {
  const [sortByField, setSortByField] = useState("");
  const [sortBy, setSortBy] = useState("");

  const [selectedValue, setSelectedValue] = useState("");
  const [count, setCount] = useState(0);
  const [sortField, setSortField] = useState("");
  const [sortDir, setSortDir] = useState("");

  const [searchText, setSearchText] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);

    if (value) {
      const [field, dir] = value.split(" ");
      setSortField(field);
      setSortDir(dir);
    } else {
      setSortField(""); // Default sort
      setSortDir("");
    }
  };
  //filter
  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
  };

  const [dockNumberOption, setDockNumberOption] = useState(null);

  const handleDockNumberDropdownChange = (option) => {
    console.log(option);
    setDockNumberOption(option);
  };

  const [dockType, setDockType] = useState("");

  const [dockTypeOptions, setDockTypeOptions] = useState([
    { label: "All", value: "" },
    { label: "Load In", value: "load_in" },
    { label: "Load Out", value: "load_out" },
  ]);

  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const handleVehicleTypeChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedVehicleType(selectedOptions);
    //setSelectedTransportLabels(selectedOptions.map((option) => option.value));
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleReset = () => {
    setSelectedVehicleType(null);
    setDockNumberOption(null);
    setDockType("");
    setStartDate(null);
    setEndDate(null);
    setSelectedLocation(null);
    getDockMasterList();
  };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const fromCreatedDate = startDate ? format(startDate, "yyyy-MM-dd") : "";
  const toCreatedDate = endDate ? format(endDate, "yyyy-MM-dd") : "";

  //filter over

  const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("dock");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [docks, setDocks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterParams, setFilterParams] = useState({
    createdDate: "",
    sortBy: "",
    selectedUser: "",
    date: "",
  });

  const [dockId, setDockId] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  useEffect(() => {
    if (dockId != null) {
      setIsModalOpen(true);
    }
  }, [dockId]);
  const closeModal = () => {
    setDockId(null);
    setIsModalOpen(false);
  };

  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelect = (id) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  const toggleSelectAll = () => {
    if (selectedIds.length === docks.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(docks.map((row) => row.id));
    }
  };
  /*   const apiUrl = "https://api-uat.mawalog.com/dock/v1/api/";

  useEffect(() => {
    const fetchDocks = async (offset = 0, limit = itemsPerPage) => {
      const token =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzQ2NTA2NzU0LCJleHAiOjE3NDY1OTMxNTQsIm5iZiI6MTc0NjUwNjc1NCwianRpIjoiTmRlNkswMUQxTnFaaFJVMyIsInN1YiI6IjQyMSIsInBydiI6IjlhZDU4NTc3ZmFiNmZiYzE1NTQzNGQzNTkxZWRmMTY0YTE3NzY1YWEiLCJhdXRoaWQiOjQyMSwib3JnaWQiOjEwMCwidXNlcmlkIjo0MjEsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQwMSwicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdfQ.F0LNpg7LGfL_Q08EMlsramR07UjX-BocHLlmIRHxOpY";
      try {
        let sortQuery = '';
        let dateFilter = '';
        
        // Handle sort query
        switch(filterParams.sortBy || sortBy) {
          case 'Created date - Ascending':
            sortQuery = 'created_at:asc';
            break;
          case 'Created date - Descending':
            sortQuery = 'created_at:desc';
            break;
          case 'Name - A to Z':
            sortQuery = 'gate:asc';
            break;
          case 'Name - Z to A':
            sortQuery = 'gate:desc';
            break;
          default:
            sortQuery = 'created_at:asc';
        }

        // Handle date filtering
        if (filterParams.date) {
          dateFilter = filterParams.date;
        } else if (filterParams.createdDate) {
          const { startDate, endDate } = calculateDateRange(filterParams.createdDate);
          if (startDate && endDate) {
            dateFilter = `${startDate.toISOString().split('T')[0]},${endDate.toISOString().split('T')[0]}`;
          }
        }

        const queryParams = new URLSearchParams({
          limit,
          skip: offset,
          search: searchTerm,
          sort_by: sortQuery.split(':')[0],
          sort_order: sortQuery.split(':')[1],
          ...(dateFilter && { date_range: dateFilter }),
          ...(filterParams.selectedUser && { user: filterParams.selectedUser })
        }).toString();

        const response = await fetch(`${apiUrl}dockmaster?${queryParams}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();

        if (response.status === 401) {
          setDocks([]);
          setTotalCount(0);
          setPageCount(0);
          return;
        }

        if (data && data.success === true && Array.isArray(data.dockMasters)) {
          let sortedDocks = [...data.dockMasters];
          
          if (sortedDocks.length === 0 && 
              (filterParams.date || filterParams.createdDate) && 
              !sortedDocks.some(dock => dock.created_at)) {
            setDocks([]);
            setTotalCount(0);
            setPageCount(0);
            return;
          }

          if (sortBy.includes('Name')) {
            sortedDocks.sort((a, b) => {
              const aGate = (a.code || '').toLowerCase();
              const bGate = (b.code || '').toLowerCase();
              return sortBy === 'Name - A to Z' 
                ? aGate.localeCompare(bGate)
                : bGate.localeCompare(aGate);
            });
          }
          
          setDocks(sortedDocks);
          setTotalCount(data.totalCount ?? sortedDocks.length);
          setPageCount(Math.ceil((data.totalCount ?? sortedDocks.length) / limit));
        } else {
          setDocks([]);
          setTotalCount(0);
          setPageCount(0);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setDocks([]);
        setTotalCount(0);
        setPageCount(0);
      }
    };

    fetchDocks(itemOffset, itemsPerPage);
  }, [itemOffset, itemsPerPage, searchTerm, sortBy, filterParams, isFilterOpen]); */

  const calculateDateRange = (filter) => {
    const today = new Date();
    let startDate, endDate;

    switch (filter) {
      case "This week":
        startDate = new Date(today.setDate(today.getDate() - today.getDay()));
        endDate = new Date(today.setDate(startDate.getDate() + 6));
        break;
      case "Last week":
        startDate = new Date(today.setDate(today.getDate() - today.getDay() - 7));
        endDate = new Date(today.setDate(startDate.getDate() + 6));
        break;
      case "This month":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "Last month":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        startDate = null;
        endDate = null;
    }

    return { startDate, endDate };
  };

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % docks.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setItemOffset(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setItemOffset(0);
  };

  const handleSortChange = (sortOption) => {
    setSortBy(sortOption);

    // Force a refetch by resetting offset
    setItemOffset(0);
  };

  const handleFilterApply = (filters) => {
    // Update sortBy state if it changed in filter
    if (filters.sortBy) {
      setSortBy(filters.sortBy);
    }

    setFilterParams({
      ...filters,
      date: filters.createdDate ? "" : filters.date,
      createdDate: filters.date ? "" : filters.createdDate,
    });
    setIsFilterOpen(false);
    setItemOffset(0);
  };

  const FilterPanel = ({ isOpen, onClose, onApply, initialFilters }) => {
    const [localFilters, setLocalFilters] = useState({
      ...initialFilters,
      sortBy: initialFilters.sortBy || sortBy, // Sync with parent sortBy
    });

    const handleDateOptionChange = (value) => {
      setLocalFilters({
        ...localFilters,
        createdDate: value,
        date: "", // Clear specific date when date option is selected
      });
    };

    const handleSpecificDateChange = (event) => {
      setLocalFilters({
        ...localFilters,
        date: event.target.value,
        createdDate: "", // Clear date option when specific date is selected
      });
    };

    //filter css
    const styles = {
      container: {
        position: "fixed",
        top: 0,
        right: 0,
        transform: isOpen ? "translateX(0)" : "translateX(100%)",
        height: "100%",
        width: "320px",
        backgroundColor: "#fff",
        transition: "transform 0.3s ease-in-out",
        zIndex: 1000,
        fontFamily: "Epilogue",
      },
      panel: {
        padding: "5px 20px 5px 20px",
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
      },
      title: {
        fontSize: "18px",
        fontWeight: "700",
        fontFamily: "Epilogue",
        color: "#172B4D",
      },
      closeIcon: {
        background: "none",
        border: "1px solid #D4DDE7",
        borderRadius: "100px",
        padding: "8px",
        height: "40px",
        width: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      },
      sectionTitle: {
        fontSize: "16px",
        fontWeight: "700",
        fontFamily: "Epilogue",
        color: "#172B4D",
        marginBottom: "10px",
      },
      radioGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginBottom: "11px",
      },
      radioLabel: (active) => ({
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "13px",
        fontFamily: "Epilogue",
        paddingTop: "8px",
        paddingBottom: "8px",
        fontWeight: 500,
        lineHeight: "100%",
        letterSpacing: "0%",
        verticalAlign: "middle",
        color: active ? "#D35258" : "#172B4D",
        cursor: "pointer",
      }),
      radioInput: (isActive) => ({
        width: "16px",
        height: "16px",
        border: "2px solid #D35258",
        borderRadius: "50%",
        background: isActive ? "radial-gradient(circle, #D35258 0%, #D35258 40%, transparent 41%)" : "#fff",
        cursor: "pointer",
        transition: "0.2s ease",
        display: "inline-block",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        outline: "none",
      }),

      dateInput: {
        width: "100%",
        padding: "10px",
        height: "36px",
        borderRadius: "12px",
        border: "none",
        backgroundColor: "#FFE9EA",
        color: "#172B4D",
        fontSize: "13px",
        marginTop: "8px",
        outline: "none",
      },
      select: {
        width: "100%",
        height: "36px",
        padding: "10px",
        borderRadius: "12px",
        border: "1px solid #EBEBEB",
        fontSize: "13px",
        outline: "none",
      },
      modalFooter: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "30px",
      },
      resetButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: "#f0f0f0",
        color: "#001f3f",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "13px",
      },
      applyButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: "#D35258",
        color: "#ffff",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "13px",
      },
    };

    //filter modal
    return (
      <div>
        <style>{`
        .custom-datepicker {
          background-color: #ffffff !important;
          color: #172b4d !important;
          font-weight: 500 !important;
          font-size: 13px !important;
          cursor: pointer;
          height:40px;
        }
      
        .custom-datepicker::placeholder {
          color: #8790A1 !important;
          font-weight: 500;
          font-size: 13px;
        
        }

        .react-datepicker-wrapper{
          width:100% !important;
        }
      `}</style>
        <div className="container-fluid" style={{ ...styles.container, overflowY: "auto" }}>
          <div className="row" style={styles.panel}>
            <div className="col-12" style={styles.header}>
              <div style={styles.title}>FILTER</div>
              <div style={styles.closeIcon} onClick={onClose}>
                <img src={close} alt="close" style={{ width: "14px", height: "14px" }} />
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Location</div>
                <div style={{ width: "100%" }}>
                  <div style={{ width: "100%", borderRadius: "8px", fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>
                    <SearchWithAPI onDropdownChange={handleLocationChange} apiUrl={apiAdminUrl + `get_location`} params={{}} placeholder={"Select"} selectedOption={selectedLocation} />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Dock</div>
                <div style={{ width: "100%" }}>
                  <div style={{ width: "100%", borderRadius: "8px", fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>
                    <SearchWithAPI onDropdownChange={handleDockNumberDropdownChange} apiUrl={apiUrl + `dockmaster/autosuggestion`} params={{}} placeholder={"Select"} selectedOption={dockNumberOption} />
                  </div>{" "}
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d", marginBottom: "10px" }}>Dock Type</div>
                <div style={{ width: "100%" }}>
                  <div className="style-justify-start" style={{ flexWrap: "wrap", gap: "8px" }}>
                    {dockTypeOptions.map((type, index) => (
                      <label className={`${dockType === type.value ? "dock-type-txt-active" : "dock-type-txt-inactive"}`}>
                        <input
                          type="radio"
                          name="options"
                          value={type.value}
                          checked={dockType === type.value}
                          onChange={(event) => {
                            setDockType(event.target.value);
                          }}
                          className="custom-radio"
                        />
                        <span className={`px-2 ${dockType === type.value ? "dock-type-txt-active" : "dock-type-txt-inactive"}`}>{type.label}</span>
                      </label>
                    ))}
                  </div>{" "}
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Vehicle Type</div>

                <div style={{ width: "100%", borderRadius: "8px", fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>
                  <SearchWithAPI onDropdownChange={handleVehicleTypeChange} apiUrl={apiUrl + "vehicletype/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={selectedVehicleType} />
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Date</div>
                <div style={{ width: "100%" }}>
                  <div style={{ borderRadius: "8px", fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>
                    <DatePicker selected={startDate} onChange={handleDateChange} startDate={startDate} endDate={endDate} selectsRange placeholderText="Select date range" className="form-control rounded-3 custom-datepicker" style={{ backgroundColor: "#F8F8F8", color: "#8790A1", cursor: "pointer" }} />
                  </div>{" "}
                </div>
              </div>
            </div>

            <div className="col-12 mt-4 d-flex justify-content-between" style={styles.modalFooter}>
              <button className="btn btn-light" style={styles.resetButton} onClick={handleReset}>
                Reset
              </button>
              <button className="btn btn-danger" style={styles.applyButton} onClick={getDockMasterList}>
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (selectedLocation == null && selectedVehicleType == null && dockNumberOption == null && dockType == "" && startDate == null && endDate == null) {
      getDockMasterList();
    }
  }, [searchText, sortField, sortDir, itemsPerPage, itemOffset, selectedLocation, dockNumberOption, dockType, selectedVehicleType, startDate, endDate]);

  const getDockMasterList = async () => {
    try {
      //'sortBy=$sortbyorder&sortByField=$sortbyfiledname&location_id=${filterby[0]['Locationid']}&dock_id=${filterby[0]['dockid']}&dock_type=${filterby[0]['docktypeid']}&vehicletype_id=${filterby[0]['vehicletypeid']}&from_dock_in=${filterby[0]['from_dock_in']}&to_dock_in=${filterby[0]['to_dock_in']}&from_dock_out=${filterby[0]['from_dock_out']}&to_dock_out=&status=${filterby[0]['to_dock_out']}&search=&limit=$itemperpagecount&skip=${currentPages * itemperpagecount}'
      const response = await getDockMasterListApi(`search=${searchText}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&sort_field=${sortField}&sort_dir=${sortDir}&location_id=${selectedLocation ? selectedLocation.value : ""}&dock_id=${dockNumberOption ? dockNumberOption.value : ""}&dock_type=${dockType}&vehicletype_id=${selectedVehicleType ? selectedVehicleType.value : ""}&from_date=${fromCreatedDate}&to_date=${toCreatedDate}`);
      if (response.data.success === true) {
        setDocks(response.data.docks);
        setCount(response.data.total_rec);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const onSuccessDock = async (response) => {
    setIsModalOpen(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    getDockMasterList();
  };
  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenBulkDelete, setIsOpenBulkDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getDockMasterList();
    }
  };

  const cancelBulkDelete = () => {
    setIsOpenBulkDelete(false);
  };
  const onSuccessBulkDelete = (response) => {
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setSelectedIds([]);
      setIsOpenBulkDelete(false);
      getDockMasterList();
    }
  };
  return (
    <div className="dockmaster-container">
      {isOpenDelete && <DeleteModal deleteUrl={`dockmaster/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      {isOpenBulkDelete && <DeleteModal ids={selectedIds} deleteUrl={`dockmaster/bulkdelete`} onSuccess={onSuccessBulkDelete} onCancel={cancelBulkDelete} />}
      {/* Header */}
      <div className="dockmaster-header">
        {/* <div
          className="dockmaster-back-button"
          onClick={() => {
            navigate(-1);
          }}>
          <img src={back} alt="Back" className="dockmaster-backicon" />
        </div>
        <h1>Admin Setup</h1> */}
      </div>

      {/* Card Content */}
      <div className="dockmaster-card">
        {/* Tabs */}
        <div className="dockmaster-tabs">
          <Link to="/dockmaster" className={`dockmaster-tab ${activeTab === "dock" ? "active" : ""}`} onClick={() => setActiveTab("dock")}>
            <img src={dock} alt="Dock" className="dockmaster-doc-icon" />
            Dock Master
          </Link>
          <Link to="/vehicletype" className={`dockmaster-tab flex items-center ${activeTab === "vehicle" ? "active" : ""}`} onClick={() => setActiveTab("vehicle")}>
            <img src={vehicle} alt="Vehicle" className="dockmaster-vih-icon" />
            Vehicle Type
          </Link>
        </div>

        {/* Top Toolbar */}
        <div className="top-bar flex flex-col md:flex-row md:items-center md:justify-between">
          <h2 className="title text-xl font-semibold">Dock Master ({count})</h2>

          <div className="action-group flex flex-col md:flex-row flex-wrap md:justify-end w-full md:w-auto">
            <div className="toolbar flex flex-col md:flex-row flex-wrap w-full md:w-auto">
              {/* Search Box */}
              <div className="search-box flex items-center border rounded-md w-full md:w-auto">
                <span className="icon mr-2">
                  <img src={search} alt="search" className="search-icon w-4 h-4" />
                </span>
                <input type="text" placeholder="Search" className="outline-none w-full" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
              </div>

              {/* Sort Dropdown */}
              <button className="btn rounded-3 me-2" style={{ borderColor: "#dcdfe4" }}>
                <img src={df} />
                <select style={{ outline: "none", border: "none" }} value={selectedValue} onChange={handleChange}>
                  <option value="">Default (data created)</option>
                  <option value="name asc">Name (Asc)</option>
                  <option value="name desc">Name (Dsc)</option>
                  <option value="created asc">Date (Oldest)</option>
                  <option value="created desc">Date (Newest)</option>
                </select>
              </button>

              {/* Filter Dropdown */}
              {/* <div className="filter-dropdown relative">
                <button className="bttn filter-toggle flex items-center border rounded-md" onClick={() => setIsFilterOpen(true)}>
                  <span className="icon">
                    <img src={filter} alt="filter" className="btn-icon w-4 h-4" />
                  </span>
                  Filter
                </button>
              </div> */}

              {/* Add Button */}
              <button className="addbtn bttn flex items-center bg-blue-600 text-white rounded-md" onClick={() => setIsModalOpen(true)}>
                <span className="icon">
                  <img src={plus} alt="add" className="btn-icon w-4 h-4" />
                </span>
                Add
              </button>
              {selectedIds.length > 0 && (
                <button
                  className="addbtn bttn flex items-center bg-blue-600 text-white rounded-md"
                  onClick={() => {
                    setIsOpenBulkDelete(true);
                  }}>
                  {/* <span className="icon">
                  <img src={plus} alt="add" className="btn-icon w-4 h-4" />
                </span> */}
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="table-container table-responsive">
          <table className="dock-table">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" checked={selectedIds.length === docks.length} onChange={toggleSelectAll} />
                </th>
                <th>Code</th>
                <th>Display</th>
                <th>Name</th>
                <th>Location</th>
                <th>Available Time</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {docks.length > 0 ? (
                docks.map((dock, i) => (
                  <tr key={i}>
                    <td>
                      <input type="checkbox" checked={selectedIds.includes(dock.id)} onChange={() => toggleSelect(dock.id)} />
                    </td>
                    <td className="truncate-cell">{dock.code || "N/A"}</td>
                    <td className="truncate-cell">{dock.display_name || "N/A"}</td>
                    <td className="truncate-cell">{dock.name || "N/A"}</td>
                    <td className="truncate-cell">{dock.location || "N/A"}</td>
                    <td className="truncate-cell">
                      {dock.available_in_time ?? ""} {dock.available_out_time !== null && dock.available_out_time !== "" ? "-" : ""} {dock.available_out_time ?? ""}
                    </td>

                    <td className="truncate-cell hover-time-cell group">
                      <span className="time-value">{dock.description || "N/A"}</span>
                      <div className="time-actions">
                        <button
                          onClick={() => {
                            setDockId(dock.id);
                          }}
                          className="icon-btn edit-btn"
                          title="Edit">
                          <img src={edit} alt="Edit" className="icon-img" />
                        </button>
                        <button
                          onClick={() => {
                            setDeleteId(dock.id);
                          }}
                          className="icon-btn delete-btn"
                          title="Delete">
                          <img src={del} alt="Delete" className="icon-img" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-gray-500 text-base">
                    {filterParams.date || filterParams.createdDate ? (dock?.created_at ? "No data available for selected date range" : "No date available") : "No data available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <Row style={{ marginTop: "16px" }}>
          <Col>
            <div className="d-flex align-items-center justify-content-start mx-3">
              <span
                style={{
                  fontFamily: "Epilogue",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#212129",
                }}>
                Records per page :
              </span>
              <select
                className="select3"
                id="perpage"
                value={itemsPerPage}
                onChange={(event) => {
                  setItemsPerPage(event.target.value);
                }}
                style={{
                  cursor: "pointer",
                  fontFamily: "Epilogue",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18.9px",
                  color: "#212129",
                  width: "56px",
                  height: "24px",
                  borderRadius: "10px",
                  border: "0.7px solid #E5E5E5",
                  padding: "0 4px",
                  backgroundColor: "#FFFFFF",
                }}>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </Col>
          <Col>
            <div className="d-flex justify-content-end">
              <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
            </div>
          </Col>
        </Row>
        <div style={{ textAlign: "center", marginTop: "30px", fontWeight: "400", fontSize: "12px", color: "#172B4D" }}>
          Powered by{" "}
          <span>
            <img src={mawalog} />
          </span>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && <DockAdd dockId={dockId} onSuccess={onSuccessDock} setIsModalOpen={setIsModalOpen} onClose={closeModal} />}

      {/* Filter Modal */}
      {isFilterOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}>
          <div
            className="modal-content"
            style={{
              position: "relative",
              width: "320px",
              height: "100%",
              marginLeft: "auto",
              backgroundColor: "#fff",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
            }}>
            <FilterPanel isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} onApply={handleFilterApply} initialFilters={filterParams} />
          </div>
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
